import {
  I18nString,
  Settings,
  Factory,
  CountryCode,
  Deletable,
  Identifiable,
  Modifiable,
} from '../'
import { applyEntitySchema } from '../../_utils/fcdc-v2'
import { isPlainObject } from '../../_utils/fcdc-v2/json'
import { PresenceSchema } from '../schema/owners.schema'

export class Presence implements Identifiable, Modifiable, Deletable {
  id: string
  customerId: string
  countryCode: CountryCode
  settings?: Settings
  names: I18nString[]
  deleted: boolean
  created: Date
  modified: Date

  constructor(json: any) {
    this.id = json.id
    this.customerId = json.customerId
    this.countryCode = json.countryCode
    this.settings = isPlainObject(json.settings)
      ? new Settings(json.settings)
      : undefined
    this.names = Array.isArray(json.names)
      ? json.names.map((name: any) => new I18nString(name))
      : []
    this.deleted = json.deleted ? Boolean(json.deleted) : false
    this.created = new Date(json.created)
    this.modified = new Date(json.modified)
    applyEntitySchema(this, PresenceSchema, json, {
      names: [],
      settings: undefined,
    })
  }

  static getFactory(): Factory<Presence> {
    return new (class implements Factory<Presence> {
      make(json: any): Presence {
        return new Presence(json)
      }

      getTableName(): string {
        return 'presences'
      }
    })()
  }

  static getUrl(presenceId?: string): string {
    return `/presences` + (presenceId ? '/' + presenceId : '')
  }
}
